import React from 'react';
import styles from './EventCard.module.scss';
import ArrowRight from '@carbon/icons-react/es/ArrowRight.js';
import Calendar from '@carbon/icons-react/es/Calendar.js';

export interface EventCardProps {
  title: string;
  type: string;
  location: string;
  date: string;
  timezone: string;
  link?: string;
}

const EventCard: React.FC<EventCardProps> = ({ title, type, location, date, link = '#' }) => {
  const headerClass = `${styles.header} ${styles[type] || ''}`;

  return (
    <a href={link} target="_blank" className={styles.card}>
      <div className={headerClass}>
        <p className={styles.meta}>
          {type.charAt(0).toUpperCase() + type.slice(1)} | {location}
        </p>
      </div>

      <div className={styles.content}>
        <h3 className={styles.title}>{title}</h3>
      </div>

      <div className={styles.footer}>
        <div className={styles.date}>
          <Calendar size={16} data-testid="calendar-icon" />
          <span className={styles.dateText}>{date}</span>
        </div>
        <ArrowRight size={20} className={styles.icon} data-testid="arrow-right-icon" />
      </div>
    </a>
  );
};

export default EventCard;
